import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {CommunicationType} from '../../../communication/data/communicationType';
import {CustomersService} from '../../../customers/services/customers.service';
import {LeadDto} from '../../../communication/data/requests/leadDto';
import {ISelectOption} from '../../../_widget-library/fields/single-select/single-select.component';
import {Customer} from '../../../customers/data/customer';
import {FlagColor} from '../../../flag/data/flagColor';
import {CommunicationDto} from '../../../communication/data/communicationDto';
import {Mail} from '../../../communication/data/mail';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';
import {LoggerService} from '../../../logging/services/logger.service';
import {CommunicationService} from '../../../communication/services/communication.service';

@Component({
  selector: 'app-communication-editor',
  templateUrl: './communication-editor.component.html',
  styleUrls: ['./communication-editor.component.scss']
})
export class CommunicationEditorComponent implements OnInit, OnChanges {

  @Input() existing: boolean = false;
  @Input() onCustomerChange: EventEmitter<Customer>;
  @Input() comm: CommunicationDto;
  @Input() lead: LeadDto;
  @Input() newLead: { value: boolean } = {value: false};
  @Input() triggerCommChange: boolean = false;
  @Input() editorLayout: boolean = false;

  @Output() leadChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() commChange: EventEmitter<CommunicationDto> = new EventEmitter<CommunicationDto>();

  commTypeOptions: ISelectOption[];
  commDirectionOptions: ISelectOption[];
  communicationType: ISelectOption;
  communicationDirection: ISelectOption;
  communicationCustomer: Customer;

  CommunicationType = CommunicationType;


  constructor(public customerService: CustomersService,
              private loggerService: LoggerService,
              private communicationService: CommunicationService) {
    this.customerService = customerService;
    this.commTypeOptions = [
      {name: '', value: CommunicationType.Phone, icon: 'fa-phone', color: undefined},
      {name: '', value: CommunicationType.Email, icon: 'fa-at', color: undefined},
      {name: '', value: CommunicationType.Mail, icon: 'fa-envelope', color: undefined},
      {name: '', value: CommunicationType.InPerson, icon: 'fa-user', color: undefined},
      {name: '', value: CommunicationType.SMS, icon: 'fa-solid fa-message-sms', color: undefined}
    ];
    this.commDirectionOptions = [
      {name: 'In', value: false, icon: undefined, color: undefined},
      {name: 'Out', value: true, icon: undefined, color: undefined},
    ];
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.comm = changes.comm.currentValue;
    this.communicationType = this.commTypeOptions.find(x => x.value === this.comm.communication.type);
    this.communicationDirection = this.commDirectionOptions.find(x => x.value === this.comm.communication.outgoing);
    this.getTrackingNumber();

    if (this.comm.communication.eventDate === undefined || this.comm.communication.eventDate === null) {
      this.comm.communication.eventDate = new Date(this.comm.communication.creationDate.getTime());
    }
    if (changes.triggerCommChange && changes.triggerCommChange.currentValue) {
      this.commChange.emit(this.comm);
    }
  }

  onNewLead(isLead: boolean): void {
    this.leadChange.emit(isLead);
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CommunicationEditor, {
      entity: isLead,
      message: 'On new lead'
    });
  }

  getTrackingNumber(): void {
    if (!this.comm) {
      this.comm = new CommunicationDto();
    }
    if (!this.comm.mail) {
      this.comm.mail = this.communicationService.getDummyMail();
    }
    if (!this.comm.mail.trackingNumber) {
      this.comm.mail.trackingNumber = '';
    }
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CommunicationEditor, 'Get tracking number');
  }

  customerChangeHandler(customer: Customer): void {
    if (customer) {
      this.comm.communication.customerId = customer.id;
      if (this.onCustomerChange) {
        this.onCustomerChange.emit(customer);
      }
    } else {
      if (this.onCustomerChange) {
        this.onCustomerChange.emit(undefined);
      }
    }
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CommunicationEditor, {
      entity: customer,
      message: 'Customer change handler'
    });
  }

  commTypeChangeHandler(option: ISelectOption): void {
    this.comm.communication.type = option.value;
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CommunicationEditor, {
      entity: option,
      message: 'Communication type change handler'
    });
  }

  commDirectionChangeHandler(option: ISelectOption): void {
    this.comm.communication.outgoing = option.value;
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CommunicationEditor, {
      entity: option,
      message: 'Communication direction change handler'
    });
  }


  handleFlagColorChange(flagColor: FlagColor): void {
    if (flagColor >= 0) {
      this.comm.communication.flagged = true;
      this.comm.communication.flagColor = flagColor;
    } else {
      this.comm.communication.flagged = false;
    }
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CommunicationEditor, {
      entity: flagColor,
      message: 'Handle flag color change'
    });
  }
}
